import { render } from "./RichMenuTable.vue?vue&type=template&id=668e39db"
import script from "./RichMenuTable.vue?vue&type=script&lang=ts"
export * from "./RichMenuTable.vue?vue&type=script&lang=ts"
script.render = render

export default script